<template>
  <div class="page-container">
    <Header />
    <FormQuestions :get-questions-endpoint="getEndpoint" :post-questions-endpoint="postEndpoint" :poll-id="!isPollFm ? id : ''" />
    <notifications group="error" position="top center" :max="3"></notifications>
    <notifications group="success" position="top center" :max="3"></notifications>
  </div>
</template>

<script>
import Header from '../../components/quality/Header'
import FormQuestions from '../../components/quality/FormQuestions'

export default {
  name: 'QualityControl',
  components: {
    FormQuestions,
    Header
  },
  computed: {
    getEndpoint () {
      if (this.isPollFm) return '/poll/info/?store_uid=' + this.id

      return '/poll/info/'
    },
    postEndpoint () {
      if (this.isPollFm) return '/poll/result/?store_uid=' + this.id

      return '/poll/result/'
    }
  },
  props: {
    isPollFm: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      id: this.$route.params.id
    }
  }
}
</script>

<style lang="sass" scoped>

.page-container
  margin: 0 auto 30px
  max-width: 650px

  +mmin($tablet--hor)
    margin: 0 auto 40px

.quality-form
  margin-top: 40px

.quality-checkbox
  margin-bottom: 15px

.quality-title
  margin-bottom: 20px
  display: block

.quality-poll-item
  margin-bottom: 40px

.quality-btn
  width: 256px
  margin: 0 auto 200px

.error-message
  margin-top: 15px
  display: block

.radio-wrapper
  display: flex
  flex-wrap: wrap

.warning-block
  text-align: center
  margin: 150px 0 300px

.warning-block__title
  margin-bottom: 40px

</style>
